export default [
    // 采购申请列表
    {
        path: "purchase/application/list",
        name: "applicationList",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/application/index"),
    },
    {
        path: "purchase/application/update/:type",
        name: "applicationUpdate",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/application/update"),
    },
    // 采购订单
    { 
        path: "purchase/order/list",
        name: "purchaseOrderList",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/order/index"),
    },
    
    {
        path: "purchase/order/update/:type",
        name: "purchaseOrderUpdate",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/order/update"),
    },
    {
        path: "purchase/order/delivery",
        name: "purchaseOrderDelivery",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/order/update/delivery"),
    },
    {
        path: 'purchase/order/replenish/',
        name: 'purchaseOrderReplenish',
        component: () => import(/* webpackChunkName: "purchase" */"@/views/purchase/order/update/replenish")
    },
    // 验货
    {
        path: "purchase/order/inspection/:type",
        name: "purchaseInspection",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/order/update/inspection"),
    },
    // 供应商管理
    {
        path: "purchase/supplier/list",
        name: "supplierList",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/supplier/index"),
    },
    {
        path: "purchase/supplier/update/:type",
        name: "supplierUpdate",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/supplier/update"),
    },
    // 供应商产品管理
    {
        path: "purchase/supplierproduct/list",
        name: "supplierProduct",
        component: () => import((/* webpackChunkName: "purchase" */ "@/views/purchase/supplierproduct/index"))
    },
    {
        path: "purchase/supplierproduct/update/:type",
        name: "supplierProductUpdate",
        component: () => import((/* webpackChunkName: "purchase" */ "@/views/purchase/supplierproduct/update"))
    },
    // 需求预测
    {
        path: "purchase/forcast/list",
        name: "planForcast",
        component: () => import(/* webpackChunkName: "plan" */ "@/views/purchase/forcast/index"),
    },
    {
        path: "purchase/forcast/update/:type",
        name: "planForcastUpdate",
        component: () => import(/* webpackChunkName: "plan" */ "@/views/purchase/forcast/update"),
    },
    // 库存计划参数维护
    {
        path: "purchase/planparam/list",
        name: "planParam",
        component: () => import(/* webpackChunkName: "plan" */ "@/views/purchase/planparam/index"),
    },
    {
        path: "purchase/planparam/update/:type",
        name: "planParamUpdate",
        component: () => import(/* webpackChunkName: "plan" */ "@/views/purchase/planparam/update"),
    },
    // 主供应商列表
    {
        path: "purchase/supplier/list",
        name: "planSupplier",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/supplier/index"),
    },
    // 亚马逊po库存导入
    {
        path: "purchase/oneinventory/list",
        name: "oneinventoryList",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/oneinventory/index"),
    },
    {
        path: "purchase/oneinventory/update/:type",
        name: "oneinventoryUpdate",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/oneinventory/update"),
    },
    {
        path: "purchase/purchasemain/list",
        name: "purchaseMainList",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/purchasemain/index")
    },
    {
        path: "purchase/purchasemain/update/:type",
        name: "purchaseMainUpdate",
        component: () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/purchasemain/update")
    }

] 